import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ticket } from "lucide-react";
import { api } from "@/lib/api";

/** Gold strip that tells every visitor the live discount code and how to use it. */
export function OfferStrip() {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    api.get("/offers/code").then(({ data }) => setOffer(data.code ? data : null)).catch(() => {});
  }, []);

  if (!offer) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(offer.code);
      toast.success(`Code ${offer.code} copied — paste it in the cart`);
    } catch {
      toast.success(`Your code is ${offer.code} — type it in the cart`);
    }
  };

  return (
    <button
      data-testid="offer-strip"
      onClick={copy}
      className="flex w-full items-center justify-center gap-2 bg-gradient-to-r from-amber-500 via-yellow-300 to-amber-500 px-4 py-2 text-center text-[11px] font-bold text-[#0A0B0E] sm:text-xs"
    >
      <Ticket size={14} className="shrink-0" />
      <span>
        {offer.percent}% OFF on orders above {offer.min_total_text} — use code{" "}
        <span className="rounded bg-black/15 px-1.5 py-0.5 font-mono tracking-[0.15em]" data-testid="offer-strip-code">{offer.code}</span>{" "}
        in the cart
      </span>
    </button>
  );
}
